import { render } from "./AppDropdown.vue?vue&type=template&id=0367cee6"
import script from "./AppDropdown.vue?vue&type=script&lang=ts"
export * from "./AppDropdown.vue?vue&type=script&lang=ts"

import "./AppDropdown.vue?vue&type=style&index=0&id=0367cee6&lang=scss"
script.render = render

export default script